(() => {
  if (window.FASOLA_CONTINUE_SHOPPING) return;
  window.FASOLA_CONTINUE_SHOPPING = true;
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const language = (document.documentElement.lang || 'nl').slice(0, 2);
  const copy = {
    nl: { added: 'Toegevoegd aan je winkelmand. Je kunt verder winkelen.', title: 'Toegevoegd', continue: 'Verder winkelen', basket: 'Naar winkelmand', close: 'Sluiten', error: 'Toevoegen is niet gelukt. Probeer het opnieuw.' },
    de: { added: 'Zum Warenkorb hinzugefügt. Du kannst weiter einkaufen.', title: 'Hinzugefügt', continue: 'Weiter einkaufen', basket: 'Zum Warenkorb', close: 'Schließen', error: 'Hinzufügen fehlgeschlagen. Bitte versuche es erneut.' },
    en: { added: 'Added to your basket. You can continue shopping.', title: 'Added', continue: 'Continue shopping', basket: 'View basket', close: 'Close', error: 'Could not add this item. Please try again.' }
  }[language] || { added: 'Added to your basket.', error: 'Could not add this item. Please try again.' };
  const sameLanguage = path => root === '/' ? !/^\/(de|en)(\/|$)/.test(path) : path.startsWith(root);
  const isListing = path => sameLanguage(path) && !path.includes('/products/') && (path.includes('/collections/') || path.endsWith('/search') || path === root || path + '/' === root);
  let message, timeout;
  function announce(text, error) {
    if (!message) {
      message=document.createElement('div');
      message.className='fasola-add-confirmation';
      message.setAttribute('role','status');
      message.setAttribute('aria-live','polite');
      message.style.cssText='position:fixed;right:12px;left:auto;z-index:10020;width:calc(100% - 24px);max-width:420px;padding:14px;border-radius:10px;background:#193f34;color:#fff;box-shadow:0 4px 20px #0003;font:inherit;font-size:14px;line-height:1.4;font-weight:500;box-sizing:border-box';
      document.body.appendChild(message);
    }
    clearTimeout(timeout);
    message.replaceChildren();
    message.style.top=Math.max(12,(document.querySelector('.atelier-header-wrap')?.getBoundingClientRect().bottom||0)+8)+'px';
    message.style.background=error?'#8a2636':'#193f34';
    const heading=document.createElement('strong');
    heading.textContent=error?text:(copy.title||'Added');
    heading.style.cssText='display:block;font-size:16px;margin-bottom:10px;color:#fff';
    message.appendChild(heading);
    if(!error){
      const actions=document.createElement('div');
      actions.style.cssText='display:flex;gap:8px;flex-wrap:wrap';
      [[copy.continue||'Continue shopping',overview()],[copy.basket||'View basket',root+'cart']].forEach(([label,href])=>{
        const link=document.createElement('a');link.href=href;link.textContent=label;
        if(href===overview())link.addEventListener('click',()=>{try{const saved=context();if(saved&&saved.url===href)sessionStorage.setItem('fasolaRestoreShopping',JSON.stringify(saved));}catch{}});
        link.style.cssText='display:inline-flex;align-items:center;justify-content:center;min-height:44px;flex:1;padding:8px 10px;box-sizing:border-box;border:1px solid #fff8;border-radius:7px;background:#fff;color:#193f34;text-decoration:none;font-size:13px;font-weight:650';
        actions.appendChild(link);
      });
      message.appendChild(actions);
    }
    const close=document.createElement('button');
    close.type='button';close.textContent='×';close.setAttribute('aria-label',copy.close||'Close');
    close.style.cssText='position:absolute;right:6px;top:0;width:44px;height:44px;border:0;background:transparent;color:#fff;font-size:24px;cursor:pointer';
    close.addEventListener('click',()=>{message.hidden=true});
    message.appendChild(close);
    message.hidden=false;
    if(error)timeout=setTimeout(()=>{message.hidden=true},10000);
  }
  if (location.pathname.includes('/collections/') && !location.pathname.includes('/products/')) {
    try { sessionStorage.setItem('fasolaShoppingOverview', location.pathname + location.search); } catch {}
  }
  try {
    const added = sessionStorage.getItem('fasolaAddedMessage');
    if (added) { sessionStorage.removeItem('fasolaAddedMessage'); announce(added, false); }
  } catch {}
  function context() {try {return JSON.parse(sessionStorage.getItem('fasolaShoppingContext')||'null')} catch {return null}}
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]');if(!link)return;
    const url=new URL(link.href,location.href);
    if(url.origin===location.origin&&url.pathname.includes('/products/')&&isListing(location.pathname)){
      try{sessionStorage.setItem('fasolaShoppingContext',JSON.stringify({url:location.pathname+location.search,product:url.pathname,y:window.scrollY,cardTop:(link.closest('.grid__item,.product-card')||link).getBoundingClientRect().top}));}catch{}
    }
  },true);
  function overview() {
    // A direct add belongs to the listing currently on screen, not its referrer.
    if(isListing(location.pathname))return location.pathname+location.search;
    try{
      const saved=context();
      if(saved&&saved.product===location.pathname){const url=new URL(saved.url,location.origin);if(url.origin===location.origin&&isListing(url.pathname))return url.pathname+url.search;}
      if(document.referrer){const previous=new URL(document.referrer);if(previous.origin===location.origin&&isListing(previous.pathname))return previous.pathname+previous.search;}
      const savedURL=sessionStorage.getItem('fasolaShoppingOverview');
      if(savedURL){const url=new URL(savedURL,location.origin);if(url.origin===location.origin&&isListing(url.pathname))return url.pathname+url.search;}
    }catch{}
    return root+'collections/all';
  }
  function shoppingKey(raw){
    const url=new URL(raw,location.origin);
    ['oseid','osectx','_pos','_sid','_ss','preview_theme_id'].forEach(key=>url.searchParams.delete(key));
    url.searchParams.sort();
    return url.pathname+'?'+url.searchParams.toString();
  }
  let restoreActive=false;
  function restorePosition(){
    if(!isListing(location.pathname)||restoreActive)return;
    try{
      const saved=JSON.parse(sessionStorage.getItem('fasolaRestoreShopping')||'null');
      if(!saved||shoppingKey(saved.url)!==shoppingKey(location.pathname+location.search))return;
      restoreActive=true;
      const previousPolicy=history.scrollRestoration;
      history.scrollRestoration='manual';
      let cancelled=false;
      const cancel=()=>{cancelled=true};
      ['wheel','touchstart','keydown','pointerdown'].forEach(type=>window.addEventListener(type,cancel,{once:true,passive:true}));
      function align(){
        if(cancelled)return;
        const link=Array.from(document.querySelectorAll('main a[href]')).find(a=>new URL(a.href,location.href).pathname===saved.product&&a.getBoundingClientRect().height>0);
        const card=link?.closest('article,.grid__item,.product-card')||link;
        const header=document.querySelector('.atelier-header-wrap');
        const minimum=Math.max(12,header?.getBoundingClientRect().bottom||0)+12;
        const offset=Math.max(minimum,Math.min(Number(saved.cardTop)||minimum,window.innerHeight*.6));
        const top=card?window.scrollY+card.getBoundingClientRect().top-offset:Number(saved.y)||0;
        window.scrollTo({top:Math.max(0,top),behavior:'instant'});
      }
      requestAnimationFrame(()=>requestAnimationFrame(align));
      document.fonts?.ready.then(align);
      window.addEventListener('load',align,{once:true});
      const delays=[150,400,800];
      delays.forEach(delay=>setTimeout(align,delay));
      setTimeout(()=>{
        cancelled=true;sessionStorage.removeItem('fasolaRestoreShopping');
        history.scrollRestoration=previousPolicy;
        ['wheel','touchstart','keydown','pointerdown'].forEach(type=>window.removeEventListener(type,cancel));
      },900);
    }catch{}
  }
  document.addEventListener('fasola:listing-ready',restorePosition);
  function restoreWhenReady(){if(!document.querySelector('.fasola-search-products'))restorePosition();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',restoreWhenReady);else restoreWhenReady();
  window.addEventListener('pageshow',restoreWhenReady);
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.fasolaAdding === 'true' || !form.reportValidity()) return;
    form.dataset.fasolaAdding = 'true';
    const button = event.submitter || form.querySelector('[type="submit"]');
    const wasDisabled = button?.disabled;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    if(isListing(location.pathname)){
      const card=form.closest('article,.grid__item,.product-card');
      const link=card?.querySelector('a[href*="/products/"]');
      if(link){try{sessionStorage.setItem('fasolaShoppingContext',JSON.stringify({url:location.pathname+location.search,product:new URL(link.href,location.href).pathname,y:window.scrollY,cardTop:card.getBoundingClientRect().top}));}catch{}}
    }
    const body = new FormData(form);
    body.delete('return_to');
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || copy.error);
      announce(copy.added, false);
      try {
        const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('#cart-count').forEach(element => { element.textContent = cart.item_count; });
        }
      } catch {}
    } catch (error) {
      announce(error.message || copy.error, true);
    } finally {
      form.dataset.fasolaAdding = 'false';
      if (button) { button.disabled = wasDisabled; button.removeAttribute('aria-busy'); }
    }
  }, true);
})();
(() => {
 function mount(){ document.querySelectorAll('.preview-bar').forEach(bar=>{bar.classList.remove('atelier-collection-bar-fixed');bar.style.top='';}); }
 window.ATELIER_COLLECTION_BAR={mount};
 document.addEventListener('change',event=>{if(event.target.matches('.fasola-mobile-language select'))event.target.form.requestSubmit();});
 mount();document.addEventListener('shopify:section:load',mount);
})();
